import { FC } from 'react';
import cx from 'classnames';
import { HeaderEquipmentWidgetProps } from './types';
import { CatIconChevronRight } from '@blocks-react/components/Icons/ChevronRight';
import { Conditional } from '../../common/conditional';
import { SelectedEquipment } from './header-selected-equipment';
import { NoSelectedEquipment } from './header-no-selected-equipment';
import { HeaderNavItem } from '../header-nav-item/HeaderNavItem';
import { MAIN_NAV_TRACK } from '../../../constants/analyticsConstants';
import { HeaderEquipmentWidgetLoading } from './header-equipment-widget-loading/HeaderWquipmentWidgetLoading';
import styles from './HeaderEquipmentWidgetNavItem.module.scss';

export const HeaderEquipmentWidgetNavItem: FC<HeaderEquipmentWidgetProps> = ({
  isCurrent,
  label,
  onClick,
  selectedEquipmentInfo = {},
  showDivider,
  imgComp,
  classname,
  subLabel = '',
  showIcon = true,
  isinitialLoading,
  isMobileSearch = false,
  isFeatureFlag
}) => {
  const hasSelectedEquipment = !!selectedEquipmentInfo?.model;

  const clickHandler = () => {
    if (onClick) {
      onClick(hasSelectedEquipment);
    }
  };

  return (
    <Conditional
      test={!isinitialLoading}
      fallback={<HeaderEquipmentWidgetLoading isMobile={true} />}
    >
      <HeaderNavItem
        aria-label={label}
        data-testid="cat-header-equipment-widget"
        id="headerEquipmentWidget"
        isCurrent={isCurrent}
        className={cx(
          { [styles['equipment_navigation']]: subLabel },
          { [styles['header-equipment--with-divider']]: showDivider },
          {
            [(styles['equipment_navigation--mobile_search'], 'col-6')]:
              isMobileSearch
          }
        )}
        onClick={clickHandler}
        data-track-event={MAIN_NAV_TRACK.EVENT}
        data-track-attr-nltext={
          hasSelectedEquipment
            ? MAIN_NAV_TRACK.CURRENTLY_SHOPPING_DRAWER_TEXT
            : MAIN_NAV_TRACK.SELECT_EQUIPMENT_TEXT
        }
        data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
        classname={classname}
      >
        {hasSelectedEquipment ? (
          <SelectedEquipment
            {...selectedEquipmentInfo}
            isMobile
            imgComp={imgComp}
            subLabel={subLabel}
            isFeatureFlag={isFeatureFlag}
          />
        ) : (
          <NoSelectedEquipment
            label={label}
            subLabel={subLabel}
            isMobile
            isFeatureFlag={isFeatureFlag}
          />
        )}

        <Conditional test={showIcon}>
          <CatIconChevronRight className={styles['chevron-icon']} />
        </Conditional>
      </HeaderNavItem>
    </Conditional>
  );
};
